export default "/assets/images/cc-balloon-sm.ce6faac0267c4b35.png";